import { ReactElement, CSSProperties } from 'react'
import Image from 'next/image'

import Container from './style'

export interface Props {
  style?: CSSProperties
  className?: string
  id?: string
  imageSrc: string
}

function PromotionBanner({
  id,
  className,
  style,
  imageSrc,
}: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <div className="container">
        <figure className="image-container">
          <Image
            src={imageSrc}
            alt="bundling-sale"
            className="image-banner"
            layout="fill"
            objectFit="cover"
            quality={100}
          />
        </figure>
      </div>
    </Container>
  )
}

export default PromotionBanner
